import React, { useState } from 'react'
import emailjs from 'emailjs-com';
import './Contact.scss'
import { Helmet } from "react-helmet";
import NavigatorPath from "../../Tools/NavigatorPath/NavigatorPath"
import { useLocation, useNavigate } from 'react-router-dom';
import bgnobgs from '../../Images/bgnobgs.png'

export default function Contact({CitiePhone}) {
    const navigate = useNavigate()
    const location = useLocation()

    function sendEmail(e) {
        // setFormSubmiting(true)
        e.preventDefault();    //This is important, i'm not sure why, but the email won't send without it
        if (e.target.Message) e.target.Message.value = e.target.Message.value + "\nLead source: Online Booking";

        emailjs.sendForm('service_fqud6um', 'template_vdkxpnd', e.target, 'QeqW-bXHRNjRmhZ6I')
            .then((result) => {
                // setPage1(false)
                // setPage2(false)
                // setPage3(true)
                // setFormSubmiting(false)
                // navigate('/thankpage')
                // window.location.reload()  //This is if you still want the page to reload (since e.preventDefault()ncelled that behavior) 
                navigate(`/thankscontact?url=${location.pathname + location.search}`)
            }, (error) => {
                console.log(error.text);
            });
    }

    return (
        <div className="Contact">
            <Helmet>
                {/* <!-- TITLE -->  */}
                {/* <!-- Maximum of 65 characters --> */}
                <title>Contact Us | Smith & Sons Chimney | 866-907-7220 </title>
                {/* <!-- Maximum 35 characters --> */}
                <meta name="title" property="title" content="Contact Us | Smith & Sons Chimney | 866-907-7220" data-react-helmet="true" />
                <meta name="og:title" property="og:title" content="Contact Us | Smith & Sons Chimney | 866-907-7220" data-react-helmet="true" />
                {/* <!-- META --> */}
                <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
                <meta name="og:type" property="og:type" content="article" data-react-helmet="true" />
                <meta name="og:image" property="og:image" content="article" data-react-helmet="true" />
                {/* <!-- Full link to the current webpage address -->  */}
                <meta name="og:url" property="og:url" content="https://www.smithandsonschimney.com/contact" data-react-helmet="true" />
                {/* <!-- Maximum of 155 characters  --> */}
                <meta name="description" content="Get in touch with Smith & Sons Chimney | 866-907-7220 for all your chimney service needs. Contact us today for expert advice, scheduling, and answers to your questions. We're here to help!" data-react-helmet="true" />
                {/* <!-- Maximum 65 characters --> */}
                <meta name="og:description" property="og:description" content="Get in touch with Smith & Sons Chimney | 866-907-7220 for all your chimney service needs. Contact us today for expert advice, scheduling, and answers to your questions. We're here to help!" data-react-helmet="true" />
                <meta name="og:site_name" property="og:site_name" content="Contact Us | Smith & Sons Chimney | 866-907-7220" data-react-helmet="true" />
                <meta name="keywords" content="chimney sweep, chimney Inspection, Chimney Inspection, Fireplace Inspection, Fireplace Cleaning, Chimney Cleaning, Chimney Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, Chimney Inspection, Fireplace Inspection, Fireplace Cleaning, Chimney Cleaning, Chimney Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, chimney services, chimney service, Chimney Inspection, Fireplace Inspection, Fireplace Cleaning, Chimney Cleaning, Chimney Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, Chimney Insulation, Chimney Installation, Chimney Liner Repair, Chimney Pointing, Chimney Rainp Installation, Chimney Repair, Chimney Crown Repair, Chimney Restoration, Chimney Flue Installation, Chimney Flue Repair, ​Chimney Construction, Chimney Vent Installation, Chimney Flashing, Flexible Chimney Liner Installation, Chimney Damper Repair, Chimneyp Repair, Fireplace Insulation, Fireplace Installation, Fireplace Liner Repair, Fireplace Pointing, Fireplace Rainp Installation, Fireplace Repair, Fireplace Crown Repair, Fireplace Restoration, Fireplace Flue Installation, Fireplace Flue Repair, Ffireplace Construction, Fireplace Vent Installation, Fireplace Flashing, Flexible fireplace Liner Installation, Fireplace Damper Repair, Fireplacep, Blog" data-react-helmet="true" />
            </Helmet>
            <div className="MainBanner">
                <div className="MainBannerLeft">
                    <h1>CONTACT US</h1>
                    <h2>Monday - Sunday 8 a.m. - 8:00 p.m. ET</h2>
                </div>
                <div className="MainBannerRight">
                    <img src={bgnobgs} alt="Smith & Sons Chimney  contact us" />
                    <div className="MainBannerRightBubble1"></div>
                    <div className="MainBannerRightBubble2"></div>
                </div>
            </div>
            <div className="MainBanner2Top2">
                <div className="MainBanner2TopBox">
                    <h2>Here is how wen help you today.</h2>
                    <div className="MainBanner2TopBoxMenu">
                        <div className="MainBanner2TopBoxBox">
                            <h3>Help with a new service.</h3>
                            <a target='_blank' href="mailto:info@smithandsonschimney.com">info@smithandsonschimney.com</a>
                            <a target='_blank' href={`tel:${CitiePhone}`}>{CitiePhone}</a>
                        </div>
                        <div className="MainBanner2TopBoxBox">
                            <h3>Mailing address.</h3>
                            <a>Smith & Sons </a>
                        </div>
                        <div className="MainBanner2TopBoxBox">
                            <h3>Partner with us.</h3>
                            <a target='_blank' href="mailto:admin@smithandsonschimney.com">admin@smithandsonschimney.com</a>
                        </div>
                    </div>
                </div>
            </div>
           
            <div className="ContactBanner2">
                <h2>Is there anything else you'd like to know?</h2>
                <a href='/faq'>Feel free to explore our Frequently Asked Questions. <u> (FAQ) page.</u> </a>
            </div>
            <div className="ContactFirst">

                <div className="ContactFirstBody">
                    <form className="contact-form" onSubmit={sendEmail}>
                        <h4>Don't hesitate to reach out via email!</h4>
                        <h5>If you need help applying for a new service or have questions about an existing one, please send us an email. Our loan advisory team is here to assist you!</h5>
                        <h2>Full Name</h2>
                        <input type="text" name="Full_Name" required />
                        <h2>Email</h2>
                        <input type="email" name="Email" required />
                        <div className='ContactFirsthhh'>
                            <div className="ContactFirsthhhBox">
                                <h2>Phone</h2>
                                <input type="tel" name="Phone" required />
                            </div>
                            <div className="ContactFirsthhhBox">
                                <h2>State</h2>
                                <input type="text" name="Country" required />
                            </div>
                        </div>
                        <h2>Massage</h2>
                        <textarea className="Message" name="Message" id="" cols="30" rows="10" required></textarea>
                        <input type="submit" value="SEND" />
                        <input type="hidden" name="Company_From" defaultValue={`Smith and Sons, Chimney Sweep | Smith and Sons`} />
                        <input type="hidden" name="Company" defaultValue={`Smith and Sons, Chimney Sweep | Smith and Sons`} />

                    </form>
                </div>
            </div>
            <NavigatorPath />

        </div>
    )
}

